import styles from "./login-link.module.less";
import { Link } from "gatsby";
import { routes, AuthContextConsumer } from "@parksandresorts/myparks";
import SiteConfigurationStore from "components/stores/site-configuration-store";
import { extract, LanguageHelper, Icon } from "@parksandresorts/core";
import { useGlobalState } from "components/stores/global-context";

const LoginLink = () => {
  const myPagesLabel = SiteConfigurationStore.getLabel("LOGIN_MY_PAGES", "Mina sidor");
  const notExpandedSubTextLabel = SiteConfigurationStore.getLabel(
    "LOGIN_NOT_EXPANDED_SUBTEXT",
    "Logga in för att få tillgång till digitala biljetter m.m.",
  );
  const toMyPagesLabel = SiteConfigurationStore.getLabel(
    "LOGIN_TO_MY_PAGES_LABEL",
    "Se dina biljetter, årskort och köp på mina sidor",
  );
  const currentLocale = LanguageHelper.getCurrentLocale();

  const globalState = useGlobalState();

  const navigateWithMenuClose = () => {
    globalState.setValue(
      {
        showMenu: false,
        showCart: false,
        isAnimating: true,
        isAnimationDone: false,
      },
      () => {
        globalState.setValue({ isMainVisible: true });
      },
    );
  };

  return (
    <div className={styles.wrapper}>
      <AuthContextConsumer>
        {(authContext) =>
          authContext.isLoggedIn ? (
            <Link
              to={routes.HOME.getSlug(currentLocale)}
              className={styles.loginLink}
              onClick={() => navigateWithMenuClose()}
            >
              <div className={styles.textContainer}>
                <h6 className={styles.headline}>
                  <Icon name="person" className={styles.icon} size="l" />
                  {`${extract(authContext, "user.firstName")} ${extract(authContext, "user.lastName")}`}
                </h6>
                <p className={[styles.infoText, "p_tiny"].join(" ")}>{toMyPagesLabel}</p>
              </div>
              <Icon name="chevron-right" size="xxs" className={styles.linkArrow} />
            </Link>
          ) : (
            <Link
              to={routes.LOGIN.getSlug(currentLocale)}
              className={styles.loginLink}
              onClick={() => navigateWithMenuClose()}
            >
              <div className={styles.textContainer}>
                <h6 className={styles.headline}>
                  <Icon name="person" className={styles.icon} size="l" />
                  {myPagesLabel}
                </h6>
                <p className={[styles.infoText, "p_tiny"].join(" ")}>{notExpandedSubTextLabel}</p>
              </div>
              <Icon name="chevron-right" size="xxs" className={styles.linkArrow} />
            </Link>
          )
        }
      </AuthContextConsumer>
    </div>
  );
};

export default LoginLink;
